import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, Card, CardHeader, CardBody } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addNewEvidence, updateActivity, updateStatement, updateStatusActivity, uploadFile, uploadFoldersFile } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { setRequireCloseModal } from '../../../../../slices/evidence/reducer';
import useFolderPaths from '../../../../../Components/Hooks/useFolderPathsHooks';
import useFileType from '../../../../../Components/Hooks/useFileTypeHooks';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

const UploadEvidenceForm = ({ data, handleToggleModal, isOpen, activeTab, toggleTab, showDetails }) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [folderPaths, setFolderPaths] = useState([]);

	const selectorEvidences = createSelector(
		state => state.Evidences,
		evidence => ({
			isUpdating: evidence.isUpdating,
			isUpdated: evidence.isUpdated,
			isUpdateError: evidence.isUpdateError,
			requireCloseModal: evidence.requireCloseModal
		})
	);

	const { isUpdating, requireCloseModal } = useSelector(selectorEvidences);
	const { file_type } = useFileType('OTR');

	const validation = useFormik({
		initialValues: {
			// date_document_evidence: new Date(),
			document_evidence: '', 
		},
		validationSchema: Yup.object({
			// date_document_evidence: Yup.date().required('Campo requerido'),
			document_evidence: Yup.mixed()
				.required(`El archivo de evidencia es requerido`)
				// .test('documentFormat', 'Solo puede subir extensiones .pdf', value => {
				// 	if (value) {
				// 		const supportedFormats = ['pdf'];
				// 		return supportedFormats.includes(value.name.split('.').pop());
				// 	}
				// 	return true;
				// })
				.test('documentSize', 'El archivo de evidencia no puede superar el tamaño máximo de 10MB', value => {
					if (value) {
						return value.size <= 10485760;
					}
					return true;
				})
		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			setIsDisabled(true);
			let document_ids = [];
			let document_id = null;

			data.management.map(async (management_item) => {
				const folderPath = `/Evidencias/${management_item.name}/${data.activity_group.name}`;

				const formData = new FormData();
				formData.append('file', values.document_evidence);
				try {
					const responseUploadFile = await dispatch(uploadFile({ file_path: folderPath, file_type_id: file_type._id, formData: formData })).unwrap();
					document_id = responseUploadFile._id;
					document_ids.push(document_id);
					
					const evidence = {
						activity_id: data._id,
						document_id: document_id
					}
					dispatch(addNewEvidence(evidence));

					const activityUpdate = {
						...data, code : 'APR',						
						document_ids: [
							...data.document_ids,
							...document_ids
						]
					}
					dispatch(updateActivity(activityUpdate));
					dispatch(updateStatusActivity(data));
				} catch (err){
					setIsLoading(false);
					console.error('Error al subir archivo:', err);
				};
				
			})

			setIsDisabled(false);
		},
	});

	const handleFileChange = (event) => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue("document_evidence", file);
	};

	useEffect(() => {
		if (!isUpdating) {
			setIsDisabled(false);
		}
	}, [isUpdating]);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							{(showDetails ?
								<React.Fragment>
									<h6>A continuación revise los detalles de la actividad y luego cargue el archivo según lo indicado en "Evidencia".</h6>
									<div className='px-2'>
										<Card className='p-0 border-1'>
											<CardHeader className='p-2'>
												<h5 className="card-title mb-0">
													Detalles de Actividad
												</h5>
											</CardHeader>
											<CardBody className='p-2'>
												<ul className="list-unstyled mb-0 vstack gap-3">
													<li>
														<div className='row d-flex'>
															<div className="col-md-2">
																<span className="text-muted">Grupo</span>
															</div>
															<div className="col-md-10">
																<span className='rounded py-1 px-2' style={{ backgroundColor: data.activity_group.bgcolor, color: data.activity_group.txcolor }}>
																	<i className={`align-middle ${data.activity_group.icon}`}></i> {data.activity_group.name}
																</span>
															</div>
														</div>
													</li>
													<li>
														<div className='row d-flex'>
															<div className="col-md-2">
																<span className="text-muted">Estado</span>
															</div>
															<div className="col-md-10">
															<div className="col-md-10">
																<span className='rounded py-1 px-2' style={{ backgroundColor: data.activity_status.bgcolor, color: data.activity_status.txcolor }}>
																	{data.activity_status.name}
																</span>
															</div>
															</div>
														</div>
													</li>
													<li>
														<div className='row d-flex'>
															<div className="col-md-2">
																<span className="text-muted">Nombre</span>
															</div>
															<div className="col-md-10">
																<span className='fw-semibold float-end w-100'>{data.title}</span>
															</div>
														</div>
													</li>
													<li>
														<div className='row d-flex'>
															<div className="col-md-2">
																<span className="text-muted">Evidencia</span>
															</div>
															<div className="col-md-10">
															<div className="col-md-10">
																<span>
																	Requiere adjuntar archivo de "<span className='fw-bold text-decoration-underline'>{data.evidence_type.name}</span>" como evidencia de actividad ejecutada.
																</span>
															</div>
															</div>
														</div>
													</li>
												</ul>
												
											</CardBody>
										</Card>
									</div>
								</React.Fragment>
							:
								null
							)}
							<div className='vstack gap-3'>
								
								<Col lg={12}>
									<Label for="document_evidence">
										Adjuntar Archivo de Evidencia
									</Label>
									<Input
										id="document_evidence"
										name="document_evidence"
										type="file"
										onChange={handleFileChange}
									/>
									{validation.errors.document_evidence && (
										<div className="invalid-feedback d-block">
											{validation.errors.document_evidence}
										</div>
									)}
								</Col>
							</div>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isDisabled || isLoading}
					>
						{isDisabled || isLoading ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className={`${Icons.check2} label-icon`}></i>}
						Guardar
					</button>
				</div>
			</div>
		</Form>
	);
};

export default UploadEvidenceForm;